import { render } from "./mobile-menu.vue?vue&type=template&id=56c4c5a6&ts=true"
import script from "./mobile-menu.vue?vue&type=script&lang=ts"
export * from "./mobile-menu.vue?vue&type=script&lang=ts"

import "./mobile-menu.vue?vue&type=style&index=0&id=56c4c5a6&lang=scss"
/* custom blocks */
import block0 from "../left-menu/i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Flayouts%2Fmain%2Fcomponents%2Fmobile-menu%2Fmobile-menu.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__